import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { adminsService } from "@/api/admins";

export const FORBIDDEN_EVENT = "tale:forbidden";

export const useAdminAccess = () => {
    const queryClient = useQueryClient();

    // The token is part of the key so another admin signing in never reuses cached permissions
    const { data, isPending, isError } = useQuery({
        queryKey: ["admin-me", localStorage.getItem("access_token")],
        queryFn: adminsService.getMe,
        staleTime: 5 * 60 * 1000,
        retry: false,
    });

    // A 403 means the permissions changed during the session: reload them
    useEffect(() => {
        const onForbidden = () => queryClient.invalidateQueries({ queryKey: ["admin-me"] });
        window.addEventListener(FORBIDDEN_EVENT, onForbidden);
        return () => window.removeEventListener(FORBIDDEN_EVENT, onForbidden);
    }, [queryClient]);

    // If /me fails we show everything: the backend still enforces the permissions
    const canAccess = (menuKey) =>
        !menuKey || isError || Boolean(data?.fullAccess) || (data?.menuKeys ?? []).includes(menuKey);

    return { me: data, loading: isPending, canAccess };
};